export default {
  getShipperForm(state) {
    const {
      shipperForm,
    } = state;
    if (!shipperForm) {
      state.shipperForm = {
        micro: {
          id: null,
        },
        macro: {
          id: null,
        },
        base: {
          code: null,
          description: null,
        },
      };
    } else {
      state.shipperForm = shipperForm;
    }

    return state.shipperForm;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-shipper/store/getters.js